import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class A11yRovingTabindexService {
  public update(items: HTMLElement[], activeIndex: number): void {
    items.forEach((item, index) => {
      item.setAttribute('tabindex', index === activeIndex ? '0' : '-1');
    });
  }

  public moveNext(items: HTMLElement[], currentIndex: number): number {
    if (!items.length) {
      return currentIndex;
    }

    const nextIndex = (currentIndex + 1) % items.length;
    items[nextIndex].focus();

    return nextIndex;
  }

  public movePrevious(items: HTMLElement[], currentIndex: number): number {
    if (!items.length) {
      return currentIndex;
    }

    const previousIndex = (currentIndex - 1 + items.length) % items.length;
    items[previousIndex].focus();

    return previousIndex;
  }
}
